import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import { useCurrentBreakPoint } from '@telia-front/helper';
import ModalCloser from '../modal-closer/modal-closer';
const ModalHeader = (props) => {
    const currentBreak = useCurrentBreakPoint();
    const isMobile = currentBreak === 'xs' || currentBreak === 'sm';
    const { className, theme, children, backButton } = props;
    const BEM = () => {
        const classArray = ['modal__header'];
        if (theme) {
            classArray.push(`modal__header--${theme}`);
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    const renderWithBackButton = (backButton) => (React.createElement(Grid, { noWrap: true, verticalGutter: "none", align: ['middle-xs'] },
        React.createElement(GridColumn, { width: ['min'] },
            React.createElement(ModalCloser, null,
                React.createElement(Button, Object.assign({}, backButton, { variant: "secondary", icon: "#arrow-left", theme: theme })))),
        React.createElement(GridColumn, { width: ['max'] }, children)));
    return (React.createElement("div", { className: BEM(), "data-theme": theme }, backButton && isMobile ? renderWithBackButton(backButton) : children));
};
export { ModalHeader as default };
